<script lang="ts">
  import { t } from '$lib/translations'
  import { ISLANDS } from '$lib/constants'
  import IslandCard from './NewIslandCard.svelte'
  import { twMerge } from 'tailwind-merge'

  let classes = ''
  export { classes as class }

  const islandsOfficesToShow = ISLANDS.filter(({ short }) => !['EH', 'LG'].includes(short))
  const islandsInfo = islandsOfficesToShow.map(({ long, short }) => ({
    name: long,
    short,
    href: `/airports/${long.toLowerCase()}.pdf`
  }))
</script>

<section id="offices-section" class={twMerge('flex flex-col w-full relative text-black bg-cs-light-yellow', classes)}>

  <div class="absolute top-0 left-0 flex flex-col h-full w-full xl:px-28 lg:px-16 justify-center gap-8">
    <h1 class="text-6xl hidden xl:block">{$t('common.our_offices')}</h1>

    <div class="w-full grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-12 justify-center">
      {#each islandsInfo as island, i}
          <IslandCard href={island.href} islandLong={island.name} islandShort={island.short}/>
      {/each}
    </div>
  </div>
</section>
